module.exports = __webpack_public_path__ + "static/img/solution3.f2fd503.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution3.png
// module id = tUxJ
// module chunks = 1